import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class AcademyService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation ACADEMY_UPDATE(
          $id: String!
          $data: AcademyInput!
        ) {
          academyUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.academyUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation ACADEMY_DESTROY($ids: [String!]!) {
          academyDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.academyDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation ACADEMY_CREATE($data: AcademyInput!) {
          academyCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.academyCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation ACADEMY_IMPORT(
          $data: AcademyInput!
          $importHash: String!
        ) {
          academyImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.academyImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query ACADEMY_FIND($id: String!) {
          academyFind(id: $id) {
            id
            name
            propertyOwner {
              id
              fullName
              email
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.academyFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query ACADEMY_LIST(
          $filter: AcademyFilterInput
          $orderBy: AcademyOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          academyList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name
              propertyOwner {
                id
                fullName
                email
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.academyList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query ACADEMY_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          academyAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.academyAutocomplete;
  }
}
